import { KeyValueModel } from "model/api";
import { EnumTpAmb } from "model/enums/enum-tpamb";

export const TpAmbMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpAmb.Producao, "Produção"),
    new KeyValueModel(EnumTpAmb.Homologacao, "Homologação"),
];
